import { motion } from "framer-motion";
import { Coordinates } from "../../Util/Math/Coordinates";
import { Angles } from "../../Util/Math/Angles";
import { useState } from "react";
import './NoteLine.scss'
import { Note } from "../../Data/HexMap/Note";
import DisplayConfig from "../../Data/HexMap/DisplayConfig";

export function NoteLine(props:{    startNote:Note, 
                                    endNote:Note, 
                                    displayConfig:DisplayConfig
                                    double?:boolean, 
                                    arrowHead?:boolean, 
                                    hide?:boolean,
                                    animate?:boolean, 
                                    delay?:number,
                                    clickable?:boolean}){
    const [visibility, setVisibility] = useState<boolean>((props.hide)?false:true)
    const fullStart:Coordinates = new Coordinates(props.startNote.params.x, props.startNote.params.y)
    const fullEnd:Coordinates = new Coordinates(props.endNote.params.x, props.endNote.params.y)
    const startXOffset:number = (props.startNote.visible) ? props.displayConfig.getCircleRadius() : 0
    const endXOffset:number = (props.endNote.visible) ? props.displayConfig.getCircleRadius() : 0
    const fullLength:number = Angles.LineLengthFromPoints(fullStart,fullEnd)
    const arrowHeadWidth:number = (props.arrowHead) ? props.displayConfig.keyRadius/10 : 0
    const length:number = fullLength - startXOffset - endXOffset - arrowHeadWidth
    const angle:number = Angles.getAngleFromPoints(fullStart.x, fullStart.y,fullEnd.x, fullEnd.y)
    const startX:number = startXOffset
    const lineY:number = 0
    const endX:number = startX + length
    const transform:string = `rotate(${angle}) translate(${fullStart.x},${fullStart.y})`
    const transformOrigin:string = `${fullStart.x}px ${fullStart.y}px`
    const duration:number = (props.animate) ? 0.5 : 0
    const delay:number = (props.animate && props.delay) ? props.delay : 0
    const initX2:number = (props.animate) ? startX : endX
    const getLines = () => {
        if(!visibility){return null}
        const yOffset:number = props.displayConfig.keyRadius * .04
        if(props.double){
            return( 
                    <>
                        {getLine(yOffset,-yOffset)} 
                        {getLine(yOffset,0,'middle-fill-line')} 
                        {getLine(yOffset,yOffset)}
                    </>
                )
        }
        const width:number = props.displayConfig.keyRadius * .035
        return( getLine(width, 0) )
    }
    const getLine = (width:number, yOffset:number, className:string='') => {
        const y:number = lineY + yOffset
        return(
            <motion.line className={className} style={{strokeWidth:width}}
            initial={{x1:startX, y1:y, x2:initX2, y2:y}} 
            animate={{x2:endX}} 
            transition={{ duration: duration, delay:delay }}></motion.line>
        )
    }
    
    const getArrowHead = () => {
        if(!visibility || !props.arrowHead){return null}
        const getPoints = () => {
            let points:number[] = [0,arrowHeadWidth/-2,0,arrowHeadWidth/2,arrowHeadWidth,0]
            return points.join(',')
    
        }
        return <motion.polygon points={getPoints()} initial={{x:initX2}} 
                                animate={{x:endX}} 
                                transition={{ duration: duration, delay:props.delay }}/>
    }

    const toggleVisibility = () => {
        if(props.clickable){setVisibility(!visibility)}
    }
    return (<g className='note-line' onClick={toggleVisibility} style={{transformOrigin:transformOrigin}} transform={transform}>
                <line className={'click-trap'} x1={0} y1={0} x2={fullLength} y2={0} strokeWidth={25} stroke={'#0000ff'}/>
                {getLines()}
                {getArrowHead()}
            </g>)
}